<template>
    <b-list-group-item class="list-item"><span>{{stat.stageName}}</span><span class="ml-3">{{formatInterval(stat.timeAvg)}}</span></b-list-group-item>
</template>

<script>
import formatInterval from '../helpers/formatInterval'
export default {
  name: 'StatRowDisplay',
  props: {
    stat: Object
  },
  data () {
    return {}
  },
  methods: {
    formatInterval: formatInterval
  }
}
</script>

<style scoped>
    .list-item {
        display: flex;
        justify-content: space-between;
    }
</style>



// WEBPACK FOOTER //
// src/components/StatRowDisplay.vue